import { useEffect, useState } from 'react';
import apiService from '../apiService';

// Équivalent USD affiché dans le panier uniquement (prix toujours en FC) — 2026-10-24, demande banque.
// Taux réglé dans l'admin (usd_exchange_rate), lu une fois par session.
let cached = null;
let pending = null;

export function useUsdRate() {
  const [rate, setRate] = useState(cached);
  useEffect(() => {
    if (cached) return;
    pending = pending || apiService.get('/public/exchange-rate')
      .then((r) => { cached = Number(r?.usd_exchange_rate) || null; return cached; })
      .catch(() => null);
    pending.then((v) => { if (v) setRate(v); });
  }, []);
  return rate;
}

export function usdLabel(amountFc, rate) {
  if (!rate || !(amountFc > 0)) return null;
  return `≈ ${(amountFc / rate).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD`;
}
